import { IAreaExpertise } from "./areaExpertise"
import { IPageInfo } from "./generic"

export enum USER_ROLES {
    USER = "user",
    ADMIN = "administrator"
}

export interface IUserGetListResponse {
    pageInfo: IPageInfo,
    status: string,
    content: IUser[]
}

export interface IUserGenericResponse {
    status: string,
    content: IUser
}

export interface IUser {
    firstName: string,
    lastName: string,
    emailAddress: string,
    id: string,
    hasManagedAreas?: boolean,
    hasPendingRegistration?: boolean,
    area: {
        id: string,
        name: string,
        managerId: string
    },
    role: {
        id: string,
        name: string,
        permissions: string[],
        isDefaultForSuperAdmin?: boolean
    },
    managedAreas: IAreaExpertise[]
}


export interface IUserBody {
    role: USER_ROLES,
    firstName: string,
    lastName: string,
    emailAddress: string,
    password: string
}